import { createSlice } from "@reduxjs/toolkit";

const STORAGE_KEYS = {
  token: "admin_token",
  user: "admin_user",
  permissions: "admin_permissions",
};

const loadFromStorage = () => {
  try {
    const token = localStorage.getItem(STORAGE_KEYS.token);
    const userStr = localStorage.getItem(STORAGE_KEYS.user);
    const permStr = localStorage.getItem(STORAGE_KEYS.permissions);
    return {
      token: token || null,
      user: userStr ? JSON.parse(userStr) : null,
      permissions: permStr ? JSON.parse(permStr) : [],
    };
  } catch {
    return { token: null, user: null, permissions: [] };
  }
};

const persisted = loadFromStorage();

const authSlice = createSlice({
  name: "auth",
  initialState: {
    token: persisted.token,
    user: persisted.user,
    permissions: persisted.permissions,
    isInitialized: false,
  },
  reducers: {
    setAuth(state, action) {
      const { token, user, permissions } = action.payload;
      state.token = token;
      state.user = user;
      state.permissions = permissions ?? [];
      if (token) localStorage.setItem(STORAGE_KEYS.token, token);
      if (user) localStorage.setItem(STORAGE_KEYS.user, JSON.stringify(user));
      if (permissions) localStorage.setItem(STORAGE_KEYS.permissions, JSON.stringify(permissions));
    },
    clearAuth(state) {
      state.token = null;
      state.user = null;
      state.permissions = [];
      Object.values(STORAGE_KEYS).forEach((k) => localStorage.removeItem(k));
    },
    setInitialized(state) {
      state.isInitialized = true;
    },
  },
});

export const { setAuth, clearAuth, setInitialized } = authSlice.actions;

export const selectToken = (state) => state.auth.token;
export const selectUser = (state) => state.auth.user;
export const selectPermissions = (state) => state.auth.permissions;
export const selectIsInitialized = (state) => state.auth.isInitialized;
export const selectIsLoggedIn = (state) => !!state.auth.token;

/** Permission for a given slug (from backend menu slug) */
export const selectPermissionBySlug = (state, slug) =>
  state.auth.permissions.find((p) => (p.slug || "").toLowerCase() === (slug || "").toLowerCase());

/** Whether the user can view the menu identified by slug */
export const selectCanViewSlug = (state, slug) => {
  const perm = selectPermissionBySlug(state, slug);
  return perm ? !!perm.can_view : false;
};

export default authSlice.reducer;
